import React from 'react';
import { DataOverview as DataOverviewBronson } from '@vwfs-bronson/bronson-react';

export type BaseDataOverviewProps = {
    className?: string;
    icon?: string;
    title?: string;
    buttonLabel?: string;
    buttonProps?: object;
    testId?: string;
    withoutCardEffect?: boolean;
    headerLanguage?: string;
    children?: React.ReactNode;
    titleLevel?: 2 | 3 | 4 | 5 | 6;
};

/**
 * Props when button is present - `href` required
 */
type WithButton = BaseDataOverviewProps & {
    /** The {@link Button} label. */
    buttonLabel: string;
    /**
     * The URL the action button links to.
     * Required when `buttonLabel` is provided, forbidden otherwise.
     */
    href: string;
};
/**
 * Props when button is absent - `href` forbidden
 */
type WithoutButton = BaseDataOverviewProps & {
    /** The {@link Button} label. */
    buttonLabel?: undefined;
    /**
     * The URL the action button links to.
     * Must not be set when `buttonLabel` is omitted.
     */
    href?: never;
};
type DataOverviewProps = WithButton | WithoutButton;

/**
 * Wraps the Bronson React DataOverview to introduce a short-term workaround aligned with the Bronson & UX teams
 * Should be removed as soon this becomes part of the Bronson React DataOverview or another solution is found
 */
export const DataOverview: React.FC<DataOverviewProps> = ({ withoutCardEffect, ...props }) =>
    withoutCardEffect ? (
        <DataOverviewBronson style={{ boxShadow: 'none', border: 'none', paddingLeft: '0px' }} {...props} />
    ) : (
        <DataOverviewBronson {...props} />
    );
